import { AnimationAction, Object3D, Scene } from 'three'

// export type AnimatorElement

export type GameElementApi = {
  actions?: Record<string, AnimationAction>
  type?: string
  scene?: Scene
  // animator:
}
export type GameElement = {
  api: GameElementApi
  object: Object3D
}
export type GameElementRef =
  | THREE.Object3D<THREE.Event>
  | React.MutableRefObject<THREE.Object3D<THREE.Event> | null | undefined>
  | undefined

export const awaitFor = ({ compare }: { compare: () => boolean }) =>
  new Promise(res => {
    compareUntilTrue({ callback: () => res(true), compare })
  })
export const compareUntilTrue = ({ callback, compare }: { callback: () => void; compare: () => boolean }) => {
  const condition = compare()
  if (!condition) {
    setTimeout(() => compareUntilTrue({ callback, compare }), 500)
  } else {
    callback()
  }
}

// export const useAddGameElement = (ref?: MutableRefObject<Object3D>, api:  GameElementApi = {}) => {
//   const addGameElement = useSceneStore(s => s.addGameElement)
//   const { scene } = useThree()

//   const addElementToStore = (ref?: MutableRefObject<Object3D>, api:  GameElementApi = {}) => {
//     if(ref?.current) {
//       const gameElement: GameElement = { object: ref.current, api: {...api, scene} }
//       addGameElement(gameElement)
//     }
//   }

//   useEffect(() => addElementToStore(ref, api), [])

//   return addElementToStore
// }
